import {useField} from '@rocketseat/unform';
import React, {useEffect, useRef, useState} from 'react';
import ReactDatePicker from 'react-datepicker';

export default function DatePicker({name, ...props}) {
  const ref = useRef(null);
  const {fieldName, registerField, defaultValue, error} = useField(name);
  const [selected, setSelected] = useState(defaultValue);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: ref.current,
      path: 'props.selected',
      clearValue: (pickerRef) => {
        pickerRef.clear();
      },
    });
  }, [ref.current, fieldName]); // eslint-disable-line

  return (
    <>
      <ReactDatePicker
        name={fieldName}
        selected={selected}
        onChange={(date) => setSelected(date)}
        ref={ref}
        {...props}
      />
      {error && <span>{error}</span>}
    </>
  );
}
